module.exports = __webpack_public_path__ + "codeship_env.png";